export default "__VITE_ASSET__06bcbd4d__"